export default __webpack_public_path__ + "static/media/eduPurple.b06b4e8e.svg";